import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbButtonModule } from '@nebular/theme';
import { NebularModule } from '../../modules/nebular/nebular.module';

@Component({
  selector: 'ngx-pagination',
  standalone: true,
  imports: [CommonModule, NbButtonModule, NebularModule],
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnChanges {
  @Input() total: number = 0;
  @Input() perPage: number = 10;
  @Input() page?: number;
  @Output() changePage = new EventEmitter<number>();

  currentPage = 1;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['page'] && typeof this.page === 'number' && !Number.isNaN(this.page)) {
      const nextPage = Math.max(1, Math.floor(this.page));
      this.currentPage = nextPage;
    }

    if (changes['total'] || changes['perPage']) {
      const last = this.totalPages || 1;
      this.currentPage = Math.min(this.currentPage, last);
    }
  }

  get totalPages(): number {
    return Math.ceil(this.total / this.perPage);
  }

  get pages(): number[] {
    // return Array.from(new Array(this.totalPages)).map((_, i) => i + 1);
    return this.createPageNumbers(this.currentPage, this.totalPages);
  }

  private createPageNumbers(current: number, last: number) {
    const pages = [];
    const delta = 2; // number of pages before/after current

    const range = {
      start: Math.max(2, current - delta),
      end: Math.min(last - 1, current + delta),
    };

    // Always include first page
    pages.push(1);

    // Add left dots if needed
    if (range.start > 2) pages.push('blank');

    // Add middle pages
    for (let i = range.start; i <= range.end; i++) {
      pages.push(i);
    }

    // Add right dots if needed
    if (range.end < last - 1) pages.push('blank');

    // Always include last page
    if (last > 1) pages.push(last);

    return pages;
  }

  handleChangePage(page: number) {
    this.currentPage = page;
    this.changePage.emit(this.currentPage);
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.changePage.emit(this.currentPage);
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.changePage.emit(this.currentPage);
    }
  }
}
